import axios from 'axios';

import config from '../config';
import { getToken } from './utils';

const api = {
  getWithToken: url => constructApi({ url, method: 'get', token: true }),
  postWithoutToken: (url, data) => constructApi({ url, method: 'post', data }),
  get: url => constructApi({ url, method: 'get' }),
  postAsAGuest: (url, data, guestToken) =>
    constructApi({ url, method: 'post', data, token: true, guestToken }),
  post: (url, data) => constructApi({ url, method: 'post', data, token: true }),
  put: (url, data) => constructApi({ url, method: 'put', data, token: true }),
  putFile: (url, data) =>
    constructApi({ url, method: 'put', data, token: true, header: true }),
  patch: (url, data) => constructApi({ url, method: 'patch', data, token: true }),
  patchWithoutToken: (url, data) => constructApi({ url, method: 'patch', data }),
  delete: (url, data) => constructApi({ url, method: 'delete', data, token: true }),
  deleteWithoutToken: (url, data) => constructApi({ url, method: 'delete', data }),
  postFormDataWithoutToken: (url, data) =>
    constructApi({ url, method: 'post', data, header: 'form' }),
  putWithoutToken: (url, data) => constructApi({ url, method: 'put', data }),
};

const constructApi = ({ url, method, data, token, header, guestToken }) =>
  axios(constructOptions(url, method, data, token, header, guestToken));

const constructOptions = (url, method, data, token, header, guestToken) =>
  data
    ? {
        ...commonOptionsParams(url, method, token, header, guestToken),
        data,
      }
    : {
        ...commonOptionsParams(url, method, token, header, guestToken),
      };

const commonOptionsParams = (resource, method, token, header, guestToken) => ({
  url: `${config.ENDPOINT}/${resource}`,
  method,
  headers: constructHeaders(token, header, guestToken),
});

const constructHeaders = (apiUseToken, apiUseUploadHeader, guestToken) => {
  const commonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  const uploadHeaders = {
    Accept: 'application/json',
    'Content-Type': 'multipart/form-data',
  };

  const formDataHeaders = {
    'Content-Type': 'application/x-www-form-urlencoded',
  };

  if (apiUseUploadHeader === 'form') {
    return { ...formDataHeaders };
  }

  if (guestToken) {
    return { ...commonHeaders, Authorization: `JWT ${guestToken}` };
  }

  if (apiUseUploadHeader && apiUseToken)
    return { ...uploadHeaders, Authorization: `JWT ${getToken()}` };

  if (apiUseToken) {
    return { ...commonHeaders, Authorization: `JWT ${getToken()}` };
  } else {
    return { ...commonHeaders };
  }
};

export default api;



// WEBPACK FOOTER //
// ./src/lib/api.js